// import config from "./config";
import { authHeader } from "../helpers/authHeader.js";
import Axios from "axios";
import userData from "../data/users.js";
import { dictionary } from "../helpers";
import { config } from "../helpers";

export const userService = {
  login,
  logout,
  getUser,
  updatePassword,
  updateUser,
  deleteUser,
  loadUsers
};

let users = userData.users;

function login(username, password) {
  const requestOptions = {
    method: "POST"    
  };
  const body = {
    username: username,
    password: password
  };

  return Axios.post(
    `${config.apiUrlTools}/Authorize/LogIn`,
    body,
    requestOptions
  ).then(handleLoginResponse);
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem(dictionary.constants.authentication.jwt);
}

function getUser(userId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  return Axios.get(
    `${config.apiUrlTools}/Authorize/me?id=` + userId,
    requestOptions
  ).then(handleGetUserResponse);
}

function updatePassword(user, password) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    userid: user.id,
    username: user.user_name,
    password: password
  };
  return Axios.post(
    `${config.apiUrlTools}/Authorize/updatePassword`,
    body,
    requestOptions
  ).then(response => {
    if (response.status != "200") {
      return Promise.reject("Password kunne ikke opdateres!");
    }

    return Promise.resolve("Password opdateret!");
  });
}

function updateUser(user, password) {
  if (user) {
    user = JSON.parse(JSON.stringify(user));
    if (!user.id || user.id === -1) {
      console.log("save new user " + user.user_name);
      console.log("Validate username!!!");

      user["id"] = Math.random();
    } else {
      console.log("update user " + user.user_name);
    }

    let index = -1;

    users.forEach(userInUsers => {
      if (userInUsers && userInUsers.id === user.id) {
        index = users.indexOf(userInUsers);
      }
    });

    if (index > -1) {
      users[index] = user;
    } else {
      users.push(user);
    }

    if (password) {
      console.log("save password " + password);
    }
  }

  return new Promise((resolve, reject) => {
    // call webservice
    const success = true;
    if (success) {
      resolve("Bruger gemt!");
    } else {
      reject("Bruger kunne ikke gemmes!");
    }
  });
}

function deleteUser(user) {
  if (user) {
    let index = users.indexOf(user);

    if (index > -1) {
      users.splice(index, 1);
    }
  }

  return new Promise((resolve, reject) => {
    // call webservice
    const success = true;
    if (success) {
      resolve("Bruger slettet!");
    } else {
      reject("Bruger kunne ikke slettes!");
    }
  });
}

function loadUsers() {
  return new Promise((resolve, reject) => {
    const success = true;
    if (success) {
      resolve(users);
    } else {
      reject("Fejl");
    }
  });
}

function handleLoginResponse(response) {
  const data = response.data;
  if (response.status != "200" || data.userId <= 0 || !data.token) {
    // auto logout if not 200 response returned from api or if userid or token is missing
    logout();
    const error = (data && data.statusDescription) || response.statusText;
    return Promise.reject(error);
  }

  // login successful if there's a jwt token in the response
  // store user details and jwt token in local storage to keep user logged in between page refreshes
  localStorage.setItem(
    dictionary.constants.authentication.jwt,
    JSON.stringify(data)
  );

  return data;
}

function handleGetUserResponse(response) {
  const data = response.data;
  if (response.status != "200") {
    return Promise.reject("Fejl");
  }

  return Promise.resolve(data);
}
